const initialState = {
    pathologyPermissions:{},
    pathologyLists: [],
    pathologyHighlightedRecord: null,
    pathologyStatus: [],
    changedPathologyStatus : [],
    loadingPathology: false,
    errorsPathology: {},
    message:"",
    pathologyId :'',
    pathologyDetails :[],
    pathologyViewDetails :[],
    radiologyPathologyAddress :[],
    errorsBasic:{},
    errorsRemark:{},
    errorsAlert:{},
    errorsBlackList:{},
    errorsGRI:{},
    errorsRate:{},
}

const  pathologyReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_PATHOLOGYLIST_PENDING":
        case "ADD_PATHOLOGY_PENDING":
        case "UPDATE_PATHOLOGY_PENDING":
        case "UPDATE_PATHOLOGY_STATUS_PENDING":
        case "DELETE_PATHOLOGY_PENDING":
        case "GET_PATHOLOGYLISTBYID_PENDING":
        case "GET_PATHOLOGYVIEWLISTBYID_PENDING":
        case "UPDATE_PATHOLOGY_OWNER_PENDING":
        case "UPDATE_PATHOLOGY_LICENSE_PENDING":
        case "UPDATE_PATHOLOGY_HOSPITAL_PENDING":
        case "UPDATE_PATHOLOGY_RATE_PENDING":
        case "UPDATE_PATHOLOGY_REMARK_PENDING":
            return { ...state, loadingPathology: true };
        case "SET_MESSAGE":
            return { ...state,
                message:action.payload 
            };
        case "EDIT_PATHOLOGY_FORM_CLOSED":
            return { 
                ...state, 
                pathologyId:"",
                pathologyDetails :[],
                radiologyPathologyAddress :[],
                errorsBasic:{},
                errorsRemark:{},
                errorsAlert:{},
                errorsBlackList:{},
                errorsGRI:{},
                errorsRate:{},
                errorsPathology:{}
            };
        case "EDIT_PATHOLOGY_FORM_FULFILLED":
            return { 
                ...state, 
                pathologyId:action.payload,
                message:"",
                errorsPathology:{}
            };
        case "GET_PATHOLOGYLIST_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                pathologyLists: action.payload,
                pathologyCount: action.count,
                pathologyPermissions:action.permissions,
                errorsPathology:{}
            };

        case "ADD_PATHOLOGY_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                pathologyDetails: action.payload?.data,
                pathologyId: action.payload?.data?.id,
                radiologyPathologyAddress: action.payload?.radiologyPathologyAddress,
                message: action.payload?.message,
                changedPathologyStatus: action.payload,
                errorsBasic:{},
                otherError:{},
                errorsPathology:{}
            };

        case "UPDATE_PATHOLOGY_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                pathologyDetails: action.payload?.data,
                pathologyId: action.payload?.data?.id,
                radiologyPathologyAddress: action.payload?.radiologyPathologyAddress,
                message: action.payload?.message,
                changedPathologyStatus: action.payload,
                errorsBasic:{},
                errorsPathology:{}
            };
        case "UPDATE_PATHOLOGY_OWNER_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                message: action.payload?.message,
                changedPathologyStatus: action.payload,
                errorsPathology:{},
            };
        case "UPDATE_PATHOLOGY_LICENSE_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                message: action.payload?.message,
                changedPathologyStatus: action.payload,
                errorsPathology:{},
            };
        case "UPDATE_PATHOLOGY_HOSPITAL_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                message: action.payload?.message,
                changedPathologyStatus: action.payload,
                errorsPathology:{},
            };
        case "UPDATE_PATHOLOGY_REMARK_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                message: action.payload?.message,
                changedPathologyStatus: action.payload,
                errorsRemark:{},
                errorsPathology:{}
            }; 
            case "UPDATE_PATHOLOGY_ALERT_FULFILLED":
                return {
                    ...state,
                    loadingPathology: false,
                    message: action.payload?.message,
                    changedPathologyStatus: action.payload,
                    errorsAlert:{},
                    errorsPathology:{}
                };
                case "UPDATE_PATHOLOGY_BLACKLIST_FULFILLED":
                    return {
                        ...state,
                        loadingPathology: false,
                        message: action.payload?.message,
                        changedPathologyStatus: action.payload,
                        errorsBlackList:{},
                        errorsPathology:{}
                    };
                    case "UPDATE_PATHOLOGY_GRI_FULFILLED":
                        return {
                            ...state,
                            loadingPathology: false,
                            message: action.payload?.message,
                            changedPathologyStatus: action.payload,
                            errorsGRI:{},
                            errorsPathology:{}
                        };
                    
        case "UPDATE_PATHOLOGY_RATE_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                message: action.payload?.message,
                changedPathologyStatus: action.payload,
                errorsRate:{},
                errorsPathology:{}
            };

        case "UPDATE_PATHOLOGY_STATUS_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                changedPathologyStatus: action.payload,
                message: action.payload?.message,
                errorsPathology:{}
            };

        case "GET_PATHOLOGYLISTBYID_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                pathologyDetails: action.payload,
                pathologyId: action.payload?.id,
                radiologyPathologyAddress: action.payload?.RadiologyPathologyAddress,
                changedPathologyStatus: action.payload,
                errorsPathology:{}
            };

        case "GET_PATHOLOGYVIEWLISTBYID_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                pathologyViewDetails: action.payload,
            };

        case "DELETE_PATHOLOGY_FULFILLED":
            return {
                ...state,
                loadingPathology: false,
                message: action.payload?.message,
                errorsPathology:{}
            };

        case "RESET_DELETE_PATHOLOGYS_STATUS":
            return {
                ...state,
                loadingPathology: false,
                changedPathologyStatus: [],
                errorsPathology:{}
            };

        case "GET_PATHOLOGYLIST_REJECTED":
        case "UPDATE_PATHOLOGY_STATUS_REJECTED":
        case "DELETE_PATHOLOGY_REJECTED":
        case "GET_PATHOLOGYLISTBYID_REJECTED":
        case "GET_PATHOLOGYVIEWLISTBYID_REJECTED":
        case "UPDATE_PATHOLOGY_OWNER_REJECTED":
        case "UPDATE_PATHOLOGY_LICENSE_REJECTED":
        case "UPDATE_PATHOLOGY_HOSPITAL_REJECTED":
        case "UPDATE_PATHOLOGY_HOSPITAL_REJECTED":
        case "UPDATE_PATHOLOGY_HOSPITAL_REJECTED":
            return {
                ...state,
                loadingPathology: false,
                errorsPathology: action.payload
            };
        case "SET_PATHOLOGY_HIGHLIGHTED_RECORD":
            return {
                ...state,
                pathologyHighlightedRecord: action.payload,
            };
        case "CLEAR_PATHOLOGY_HIGHLIGHTED_RECORD":
            return {
                ...state,
                pathologyHighlightedRecord: null,
            };

        case "ADD_PATHOLOGY_REJECTED":
        case "UPDATE_PATHOLOGY_REJECTED":
            return {
                ...state,
                loadingPathology: false,
                errorsBasic: action.payload?.data,
                errorsPathology: action.payload,
            };
        case "UPDATE_PATHOLOGY_REMARK_REJECTED":
            return {
                ...state,
                loadingPathology: false,
                errorsRemark: action.payload,
            };
            
            case "UPDATE_PATHOLOGY_ALERT_REJECTED":
                return {
                    ...state,
                    loadingPathology: false,
                    errorsAlert:action.payload,
                };  
                case "UPDATE_PATHOLOGY_BLACKLIST_REJECTED":
                    return {
                        ...state,
                        loadingPathology: false,
                        errorsBlackList: action.payload,
                    };    
                    case "UPDATE_PATHOLOGY_GRI_REJECTED":
                        return {
                            ...state,
                            loadingPathology: false,
                            errorsGRI: action.payload,
                        };    
        case "UPDATE_PATHOLOGY_RATE_REJECTED":
            return {
                ...state,
                loadingPathology: false,
                errorsRate: action.payload,
            };
        default:
            return state;
    }
}

export default pathologyReducer;